export default __webpack_public_path__ + "media/img/primary_small-f56b38ccbca264016d45778125fa6647.svg";